var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 5.83333C6.94346 5.83333 7.16732 5.60948 7.16732 5.33333C7.16732 5.05719 6.94346 4.83333 6.66732 4.83333V5.83333ZM3.33398 5.33333H2.83398C2.83398 5.60948 3.05784 5.83333 3.33398 5.83333V5.33333ZM3.83398 2C3.83398 1.72386 3.61013 1.5 3.33398 1.5C3.05784 1.5 2.83398 1.72386 2.83398 2H3.83398ZM6.66732 4.83333H3.33398V5.83333H6.66732V4.83333ZM3.83398 5.33333V2H2.83398V5.33333H3.83398Z",
    fill: "#024E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52734 10.9051C4.14856 11.8617 5.0601 12.5939 6.12812 12.9943C7.19615 13.3947 8.3644 13.4421 9.46137 13.1296C10.5583 12.8171 11.5262 12.1612 12.223 11.2581C12.9197 10.355 13.3085 9.25237 13.3324 8.11202C13.3563 6.97166 13.014 5.85368 12.3557 4.92222C11.6974 3.99075 10.7578 3.29486 9.67488 2.93672C8.59196 2.57858 7.42274 2.57705 6.33889 2.93236C5.25503 3.28766 4.31364 3.98109 3.6529 4.91083",
    stroke: "#024E82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.76c8816430061397e40bff78000d336e.svg";
export { ForwardRef as ReactComponent };